import { RootState } from 'MyTypes';

export const getDatasets = (state: RootState) => state.data.datasets;
